export class File {
    pk: number;
    name: string;
    created_at: string;
    rows_number: number;
    downloads_number: number;
    gen_type: string;
    campaign_name: string;
    typecamp: string;

    constructor(row: Object) {
        this.name = row['name'];
        this.created_at = row['created_at'];
        this.pk = row['pk'];
        this.rows_number = row['total'];
        this.downloads_number = row['user_downloads'];
        this.gen_type = row['generation_type'];
        this.campaign_name = row['campaign_name'];
        this.typecamp = row['typecamp'];
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files/model/file.ts